import Model from './Model'

export default class Import extends Model {
    resource() {
        return 'import'
    }

}
